import { BaseComponent } from '@shared/components/base.component';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UAParser } from 'ua-parser-js';
import { StorageService } from '@shared/services/storage.service';

@Component({
  selector: 'app-mobile-app-banner',
  templateUrl: './mobile-app-banner.component.html',
  styleUrls: ['./mobile-app-banner.component.scss'],
})
export class MobileAppBannerComponent extends BaseComponent implements OnInit {
  private readonly IOS_APP_STORE_META_TAG = 'apple-itunes-app';
  private readonly IOS_APP_URL = 'https://apps.apple.com/us/app/details/id';

  private readonly GOOGLE_PLAY_TAG = 'google-play-app';
  private readonly GOOGLE_PLAY_URL = 'http://play.google.com/store/apps/details?id=';

  public mobileDeviceOS: string = '';

  public isBannerVisible: boolean = false;
  public appId: string | null = null;
  public appUrl: string | null = null;

  constructor(public storage: StorageService, public cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    if (params.has('inApp') || params.get('banner') === 'false') {
      return;
    }

    if (this.storage.isMobileAppBannerHidden()) {
      return;
    }

    const ua = new UAParser(window.navigator.userAgent);

    if (!['mobile', 'tablet'].includes(ua.getDevice().type)) {
      return;
    }

    const osName = ua.getOS().name;
    if (osName != 'iOS' && !osName.startsWith('Android')) {
      return;
    }

    if (osName == 'iOS') {
      // Do not show anything on Safari - native browser banner will show up
      if (ua.getBrowser().name.includes('Safari')) {
        return;
      }

      this.mobileDeviceOS = 'ios';
      const iosMetaTag = document.querySelector(`meta[name="${this.IOS_APP_STORE_META_TAG}"]`);

      if (iosMetaTag) {
        this.appId = /app-id=([^\s,]+)/.exec(iosMetaTag.getAttribute('content'))[1];
        this.appUrl = this.IOS_APP_URL + this.appId; // TODO: language
      }
    } else {
      // Android
      this.mobileDeviceOS = 'android';
      const googlePlayMetaTag = document.querySelector(`meta[name="${this.GOOGLE_PLAY_TAG}"]`);

      if (googlePlayMetaTag) {
        this.appId = /app-id=([^\s,]+)/.exec(googlePlayMetaTag.getAttribute('content'))[1];
        this.appUrl = this.GOOGLE_PLAY_URL + this.appId;
      }
    }

    this.isBannerVisible = true;
  }

  hideBanner() {
    this.isBannerVisible = false;
    this.storage.hideMobileAppBanner();

    // This will recalculate header position
    this.cdRef.detectChanges();
    window.dispatchEvent(new Event('resize'));
  }
}
